
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 99","d":"M4.129.5h23.742A3.652 3.652 0 0131.5 4.174v15.652a3.652 3.652 0 01-3.629 3.674H4.129A3.652 3.652 0 01.5 19.826V4.174A3.652 3.652 0 014.129.5z","fill":"#fff","stroke":"#e6e6e6"}}),_c('path',{attrs:{"data-name":"Path 100","d":"M12.903 17.218a5.19 5.19 0 005.161-5.217 5.19 5.19 0 00-5.161-5.218A5.19 5.19 0 007.742 12a5.19 5.19 0 005.161 5.218z","fill":"#e7001a"}}),_c('path',{attrs:{"data-name":"Path 101","d":"M19.097 17.218a5.19 5.19 0 005.161-5.217 5.19 5.19 0 00-5.161-5.218A5.19 5.19 0 0013.936 12a5.19 5.19 0 005.161 5.218z","fill":"#f49b1c"}}),_c('path',{attrs:{"data-name":"Path 102","d":"M16.001 7.826A5.228 5.228 0 0118.065 12a5.228 5.228 0 01-2.064 4.175 5.252 5.252 0 010-8.349z","fill":"#e7001a","fill-rule":"evenodd","opacity":".3"}})])
          )
        }
      }
    